// products modules
import axios from 'axios';
import {
  CATEGORY_URL,
  DISPLAY_CATEGORY_URL,
  CATEGORY_2_URL,
  CATEGORY_2_B2B_URL,
  PRODUCT_GREAT_DEALS_URL,
  PRODUCTS_URL,
  PRODUCTS_GROUP,
  DISPLAY_PRODUCTS_GROUP,
  PRODUCT_RECIPE_URL,
} from '../../api/url.js';

// initial state
const state = {
  activeCategory: '',
  activeProduct: '',
  allGroups: [],
  customCategories: [],
  customCategoriesAll : [],
  customB2BCategories: [],
  productDetails: '',
  productsArray: [],
  singleItem: false,
  activeLanding: '',
  activeQuantity: 0,
}

// actions
const actions = {
  fetchCategories(context, data) {
    let b2b, id;
    if (typeof data === 'object') {
      b2b = data[1];
      id = data[0];
    } else {
      id = data;
    }

    if (b2b === true) {
      return axios({
        // url: `${CATEGORY_URL}${id}`,
        url: `${DISPLAY_CATEGORY_URL}${id}`,
        method: 'GET',
        params: {
          isB2B: b2b
        }
      })
    } else {
      return axios({
        // url: `${CATEGORY_URL}${id}`,
        url: `${DISPLAY_CATEGORY_URL}${id}`,
        method: 'GET',
      })
    }
  },
  async fetchCustomCategories(context, b2b) {
    let config = {};
    if (b2b) {
      config = {
        method: 'get',
        url: CATEGORY_2_URL,
        params: {
          IsListView: true,
          nested: true,
          isB2B: b2b
        },
      };
    } else if (!b2b) {
      config = {
        method: 'get',
        url: CATEGORY_2_URL,
        params: {
          IsListView: true,
          nested: true,
        },
      };
    }
    context.commit('resetCustomCategories');
    await axios(config)
    .then((response) => {
      context.commit('fetchCustomCategories', response.data);
    }, (err) => {
      console.log("fetchCustomCategories error:", err);
    })
  },
  async fetchCustomCategoriesAll(context, b2b) {
    // this it to get all included the not enable one
    let config = {};
    if (!b2b) {
      config = {
        method: 'get',
        url: CATEGORY_2_URL,
        params: {
          IsListView: true,
          nested: true,
          all: true
        },
      };
    }
    context.commit('resetCustomCategoriesAll');
    await axios(config)
      .then((response) => {
        context.commit('fetchCustomCategoriesAll', response.data);
      }, (err) => {
        console.log("fetchCustomCategoriesAll error:", err);
      })
  },
  async fetchB2BCustomCategories(context, b2b) {
    let config = {
      method: 'get',
      url: CATEGORY_2_B2B_URL,
      params: {
        IsListView: true,
        nested: false,
        isB2B: true
      },
    };
    context.commit('resetB2BCustomCategories');
    await axios(config)
    .then((response) => {
      context.commit('fetchB2BCustomCategories', response.data);
    }, (err) => {
      console.log("fetchB2BCustomCategories error:", err);
    })
  },
  async fetchProductDetails(context, productNum) {
    const config = {
      method: 'get',
      url: `${PRODUCTS_URL}${productNum}`,
    };
    context.commit('clearProductDetails');
   await axios(config)
    .then((response) => {
      context.commit('fetchProductDetails', response.data);
      context.commit('createProductsArray', response.data);
    }, (err) => {
      console.log("fetchProductDetails error:", err);
    })
  },
  fetchProductsWithGroupId(context, data) {
    let config = {};
    if (data.isB2B) {
      config = {
        url: `${DISPLAY_PRODUCTS_GROUP}/${data.id}`,
        method: 'GET',
        params: {
          isB2B: data.isB2B
        }
      }
    } else if (!data.isB2B) {
      config = {
        url: `${DISPLAY_PRODUCTS_GROUP}/${data.id}`,
        method: 'GET',
      }
    }
    return axios(config)
  },
  // fetch recipe
  fetchProductRecipe: (context, productId) => axios({
    method: 'GET',
    url: `${PRODUCT_RECIPE_URL}${productId}`,
  }),
  // fetch category2 products,  or category list, afg nit using this
  fetchProductsWithCategory2Id: ({ commit }, data) => axios({ url: `${CATEGORY_2_URL}${data}`, method: 'GET'}),
  fetchB2BProductsWithCategory2Id: ({ commit }, data) => axios({ url: `${CATEGORY_2_B2B_URL}${data}?isB2B=true`, method: 'GET'}),
};

// mutations
const mutations = {
  fetchCustomCategoriesAll(state, payload) {
    state.customCategoriesAll = payload
  },
  resetCustomCategoriesAll(state, payload) {
    state.customCategoriesAll = [];
  },
  fetchCustomCategories(state, payload) {
    state.customCategories = payload
  },
  resetCustomCategories(state, payload) {
    state.customCategories = [];
  },
  updateActiveCategory(state, data) {
    state.activeCategory = data
  },
  fetchB2BCustomCategories(state, payload) {
    state.customB2BCategories = payload
  },
  resetB2BCustomCategories(state, payload) {
    state.customB2BCategories = [];
  },
  fetchProductDetails(state, payload) {
    let newPayload;
    if (payload.length > 1) {
      newPayload = payload.sort( (a, b) => {
        return a.ConvertNum - b.ConvertNum;
      })
      state.productDetails = newPayload
    } else {
      state.productDetails = payload
    }
  },
  updateActiveProduct(state, number) {
    state.activeProduct = number
  },
  updateActiveQuantity(state, payload) {
    state.activeQuantity = payload;
  },
  clearProductDetails(state, payload) {
    state.productDetails = '';
    state.productsArray = [];
  },
  updateActiveLanding(state, payload) {
    state.activeLanding = payload;
  },
  createProductsArray(state, payload) {
    let products = [];
    payload.map(caseItems => {
      if (caseItems.ProductNum.charAt(caseItems.ProductNum.length -1) === "0") {
        products.push(
          {
            value: caseItems.Product_id,
            label: `Master Case (${caseItems.ConvertNum} Units): $${caseItems.Price}`,
            ProductNum: caseItems.ProductNum,
            Description: caseItems.Description,
            Name: caseItems.Name,
          })
        }
        if (caseItems.ProductNum.charAt(caseItems.ProductNum.length -1) === "2") {
          products.push(
            {
              value: caseItems.Product_id,
              label: `Inner Case (${caseItems.ConvertNum} Units): $${caseItems.Price}`,
              ProductNum: caseItems.ProductNum,
              Description: caseItems.Description,
              Name: caseItems.Name,
            })
          }
        });
      state.productsArray = products;
    }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js